//This file provides the function that retrieves hangman puzzles
//from the Internet.

//This imports the fetch function used below.
import 'whatwg-fetch';

//Function to make request to get puzzle.
const getPuzzle = async (letterCount) => {
    //Make an HTTP request with fetch.  Note that this request
    //accesses a publicly-available API.
    const response = await 
        fetch('//random-word-api.herokuapp.com/word?length='
            + letterCount);

    //Check for response status.
    if (response.status === 200) {
        //Request is finished and successful, so convert JSON into
        //a Javascript object which, per the API, is a single-
        //element array.
        const data = await response.json();
        //Return the array element, a random word to caller.
        return data[0];
    } else {
        //Return rejected promise to caller via exception.
        throw new Error('An error has taken place');
    }
}

//Export getPuzzle(...) function as default.
export {getPuzzle as default}